"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var mobileRouter = {
  path: '/javaMobile',
  component: _layout.default,
  redirect: '/javaMobile/index',
  name: 'Mobile',
  alwaysShow: true,
  meta: {
    title: '移动端',
    icon: 'clipboard'
  },
  children: [{
    path: 'orderCancellation',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderCancellation/index.vue'));
      });
    },
    name: 'OrderCancellation',
    meta: {
      title: '订单核销',
      icon: ''
    }
  }, {
    path: 'orderStatistics',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/index.vue'));
      });
    },
    name: 'OrderStatistics',
    meta: {
      title: '订单统计'
    }
  }, {
    path: 'orderList/:types?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/orderList.vue'));
      });
    },
    name: 'OrderList',
    meta: {
      title: '订单列表'
    }
  }, {
    path: 'orderDelivery/:oid/:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/orderDelivery.vue'));
      });
    },
    name: 'OrderDelivery',
    meta: {
      title: '订单发货'
    }
  }, {
    path: 'orderDetail/:id?/:goname?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/orderDetail.vue'));
      });
    },
    name: 'OrderDetail',
    meta: {
      title: '订单详情'
    }
  }, {
    path: 'orderStatisticsDetail/:type/:time?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mobile/orderStatistics/Statistics.vue'));
      });
    },
    name: 'OrderStatisticsDetail',
    meta: {
      title: '订单数据统计'
    }
  }]
};
var _default = exports.default = mobileRouter;